var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { id: "home", "fill-height": "", fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c("v-col", [
            _c("h1", { staticClass: "text-center" }, [
              _vm._v("PÁGINA NÃO FOI ENCONTRADA, ESTAMOS TE REDIRECIONANDO"),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }